import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

export const StaticPart = styled.div`
  font-size: 12px;
  margin: 4px 16px 4px 38px;
  opacity: 0.5;
  font-weight: 700;
`

export const PocketSection = styled.div`
  border-top: 1px solid ${themeColor('greySecondary')};
  margin: 8px 0px 0px;
  padding: 8px 0px;
`
